module.exports = __webpack_public_path__ + "static/img/icon_music-2.5192112b.svg";